import { RewardsStatsigFeatureGate } from './feature-gate'

export const RewardsStatsig = {
  FeatureGate: RewardsStatsigFeatureGate,
}
